module.exports = __webpack_public_path__ + "static/img/bg.c4e4a58.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/bg.png
// module id = B8KY
// module chunks = 1